import * as React from 'react'
import { SVGProps } from 'react'

const SvgFinblox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M285 319c6.627 0 12 5.373 12 12v68c0 6.627-5.373 12-12 12h-68c-6.627 0-12-5.373-12-12v-68c0-6.627 5.373-12 12-12h68Zm114 0c6.627 0 12 5.373 12 12v68c0 6.627-5.373 12-12 12h-68c-6.627 0-12-5.373-12-12v-68c0-6.627 5.373-12 12-12h68Zm-230 0c6.627 0 12 5.373 12 12v68c0 6.627-5.373 12-12 12h-68c-6.627 0-12-5.373-12-12v-68c0-6.627 5.373-12 12-12h68Zm230-116c6.627 0 12 5.373 12 12v68c0 6.627-5.373 12-12 12h-68c-6.627 0-12-5.373-12-12v-68c0-6.627 5.373-12 12-12h68Zm-114 0c6.627 0 12 5.373 12 12v68c0 6.627-5.373 12-12 12h-68c-6.627 0-12-5.373-12-12v-68c0-6.627 5.373-12 12-12h68ZM399 89c6.627 0 12 5.373 12 12v68c0 6.627-5.373 12-12 12h-68c-6.627 0-12-5.373-12-12v-68c0-6.627 5.373-12 12-12h68Z"
      fill="url(#Finblox_svg__a)"
    />
    <defs>
      <linearGradient
        id="Finblox_svg__a"
        x1={89}
        y1={250}
        x2={411}
        y2={250}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0091FF" />
        <stop offset={1} stopColor="#0278FD" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgFinblox
